import axios from "@/utils/useAxios";
import { useMutation } from "@tanstack/react-query";
import { LoginDTO } from "../login/_misc/components/LoginFormAdmin";
import { IAdminLogin } from "./type";
import { toast } from "react-toastify";
import { errorLogger } from "@/utils/helper";

export const useRegister = () => {
  return useMutation({
    mutationKey: ["Register"],
    mutationFn: async (payload: any) => {
      const response = await axios.post("/admin/register", payload);
      return response.data.data as IAdminLogin;
    },
  });
};

export const useRegisterMerchant = ({ token }: { token: string }) => {
  return useMutation({
    mutationKey: ["register-merchant"],
    mutationFn: async (payload: any) => {
      const response = await axios.post(
        `/clientmerchants/create?token=${token}`,
        payload
      );
      return response.data.data as IAdminLogin;
    },
  });
};

export const useAdminLogin = () => {
  return useMutation({
    mutationKey: ["admin_login"],
    mutationFn: async (payload: LoginDTO) => {
      const response = await axios.post("/admin/login", payload);

      return response.data.data as IAdminLogin;
    },
  });
};

export const useMerchantLogin = () => {
  return useMutation({
    mutationKey: ["merchant-login"],
    mutationFn: async (payload: LoginDTO) => {
      const response = await axios.post("/clientmerchants/login", payload);

      return response.data.data as IAdminLogin;
    },
  });
};

export const useForgotUserPassword = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  return useMutation({
    mutationKey: ["forgot-user-password"],
    mutationFn: async (payload: any) => {
      const response = await axios.post(
        "clientmerchants/forgot-password",
        payload
      );
      return response.data.data as any;
    },
    onSuccess: () => {
      onSuccess();
      toast.success("Check your email for Link and OTP to reset your password");
    },
    onError: (error) => {
      errorLogger(error);
    }, 
  });
};

export const useResendOTPUser = ({ onSuccess }: { onSuccess: () => void }) => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await axios.post("clientmerchants/resend-otp", payload);
      return response.data.data as any;
    },
    onSuccess: () => {
      onSuccess();
      toast.success("Check your email for Link and OTP to reset your password");
    },
    onError: (error) => {
      errorLogger(error);
    },
  });
};

export const useResendOTPAdmin = ({ onSuccess }: { onSuccess: () => void }) => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await axios.post("admin/resend-otp", payload);
      return response.data.data as any;
    },
    onSuccess: () => {
      onSuccess();
      toast.success("Check your email for Link and OTP to reset your password");
    },
    onError: (error) => {
      errorLogger(error);
    },
  });
};

export const useResetPasswordUser = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  return useMutation({
    mutationKey: ["reset-user-password"],
    mutationFn: async (payload: any) => {
      const response = await axios.put(
        "clientmerchants/reset-password",
        payload
      );
      return response.data.data as any;
    },
    onSuccess: () => {
      onSuccess();
      toast.success("Password Reset Successfully");
    },
    onError: (error) => {
      errorLogger(error);
    },
  });
};

export const useForgotAdminPassword = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  return useMutation({
    mutationKey: ["forgot-admin-password"],
    mutationFn: async (payload: any) => {
      const response = await axios.post("admin/forgot-password", payload);
      return response.data.data as any;
    },
    onSuccess: () => {
      onSuccess();
      toast.success("Check your email for Link and OTP to reset your password");
    },
    onError: (error) => {
      errorLogger(error);
    },
  });
};

export const useResetPasswordAdmin = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  return useMutation({
    mutationKey: ["reset-admin-password"],
    mutationFn: async (payload: any) => {
      const response = await axios.put("admin/reset-password", payload);
      return response.data.data as any;
    },
    onSuccess: () => {
      onSuccess();
      toast.success("Password Reset Successfully");
    },
    onError: (error) => {
      errorLogger(error);
    },
  });
};
